import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';
import { navigationItems } from '../../config/navigation';
import BookingModal from '../BookingModal';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const openBookingModal = () => {
    setIsBookingModalOpen(true);
    setIsMenuOpen(false);
  };

  const handleNavigation = (href: string) => {
    setIsMenuOpen(false);
    
    const [path, hash] = href.split('#');
    
    if (path === '/' || path === '') {
      if (location.pathname === '/') {
        // If already on homepage, just scroll to top or section
        if (hash) {
          const element = document.getElementById(hash);
          element?.scrollIntoView({ behavior: 'smooth' });
        } else {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      } else {
        // Navigate to homepage and handle scroll after navigation
        navigate('/', { state: { scrollTo: hash } });
      }
    } else {
      // Navigate to other pages
      navigate(href);
    }
  };

  const handleLogoClick = () => {
    handleNavigation('/');
  };

  return (
    <>
      <header className="fixed w-full bg-white/95 backdrop-blur-sm z-50 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <button
                onClick={handleLogoClick}
                className="text-2xl font-bold text-blue-600 hover:text-blue-700 transition-colors"
              >
                CertiFrance
              </button>
            </div>
            
            <nav className="hidden md:flex items-center space-x-8">
              {navigationItems.map((item) => (
                <button
                  key={item.label}
                  onClick={() => handleNavigation(item.href)}
                  className="text-gray-600 hover:text-blue-600 transition-colors"
                >
                  {item.label}
                </button>
              ))}
              <button 
                onClick={openBookingModal}
                className="bg-green-500 text-white px-6 py-2 rounded-full hover:bg-green-600 transition-colors"
              >
                Consultation gratuite
              </button>
            </nav>

            <button 
              className="md:hidden"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label={isMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
            >
              {isMenuOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <nav className="md:hidden bg-white border-t">
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navigationItems.map((item) => (
                <button
                  key={item.label}
                  onClick={() => handleNavigation(item.href)}
                  className="block w-full text-left px-3 py-2 text-gray-600 hover:text-blue-600 transition-colors"
                >
                  {item.label}
                </button>
              ))}
              <button 
                onClick={openBookingModal}
                className="w-full mt-2 bg-green-500 text-white px-6 py-2 rounded-full hover:bg-green-600 transition-colors"
              >
                Consultation gratuite
              </button>
            </div>
          </nav>
        )}
      </header>

      <BookingModal 
        isOpen={isBookingModalOpen}
        onClose={() => setIsBookingModalOpen(false)}
      />
    </>
  );
};

export default Header;